import CriteriaPropertyField from './CriteriaPropertyField';

export default CriteriaPropertyField;
